module.exports = __webpack_public_path__ + "img/icon-drop-down.767b788d.svg";